import Vue from "vue";

import {
    Button,
    Toast,
    Swipe,
    SwipeItem,
    Field,
    Tab,
    Tabs,
    Lazyload,
    Icon,
    NavBar,
    Popup,
} from "vant";

Vue.use(Button);
Vue.use(Toast);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Field);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Icon);
Vue.use(NavBar);
Vue.use(Popup);

Vue.use(Lazyload, {
    lazyComponent: true,
    loading: require('./../assets/images/default.png'), //加载中图片，一定要有，不然会一直重复加载占位图
    error: require('./../assets/images/default.png'),   // 加载失败图片
    attempt: 1  // <<= 图片加载失败后的重试次数.默认为3
});
